import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Role',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Role',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Role',
    column_type: 'datetime',
  },
  name: {
    model_name: 'Role',
    column_type: 'string',
  },
  kind: {
    model_name: 'Role',
    column_type: 'enum',
  },
  custom_permissions: {
    model_name: 'Role',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
